import { useState, useEffect } from "react";

/**
 * Hook to track elapsed time from a start time in real-time
 * @param startTime - ISO date string when the timer should start from
 * @param isRunning - Whether the timer should be actively counting
 * @returns Elapsed time in milliseconds
 */
export function useElapsedTime(startTime: string | null | undefined, isRunning: boolean) {
  const [elapsedMs, setElapsedMs] = useState<number>(0);

  useEffect(() => {
    if (!startTime || !isRunning) {
      setElapsedMs(0);
      return;
    }

    const start = new Date(startTime).getTime();
    
    const updateElapsed = () => {
      setElapsedMs(Math.max(0, Date.now() - start));
    };

    updateElapsed();
    const interval = setInterval(updateElapsed, 1000);

    return () => clearInterval(interval);
  }, [startTime, isRunning]);

  return elapsedMs;
}
